import { ResourceUsage } from "@/types/subscription"

export const defaultQueryFn = async ({ queryKey }: { queryKey: any }): Promise<any> => {
  return await cosineFetch(queryKey[queryKey.length - 1])
}

export type Method = "get" | "post" | "put" | "delete" | "PATCH"

export const localhostUrl = "http://localhost:3001"

export const localhostDashboardUrl = "http://localhost:3000"

export const baseUrl: string =
  process.env.API_URL ?? process.env.NEXT_PUBLIC_API_URL ?? localhostUrl

export const dashboardUrl: string = process.env.NEXT_PUBLIC_DASHBOARD_URL ?? localhostDashboardUrl

type FileRes = {
  success: boolean
  fileKey: string
  signedUrl: string
}
export const cosineUpload = async (path: string, formData: FormData): Promise<FileRes> => {
  const response = await fetch(`${baseUrl}${path}`, {
    method: "POST",
    body: formData,
    credentials: "include",
  })

  if (!response.ok) {
    throw new Error("Failed to upload file")
  }

  const data = await response.json()
  if (!data.success) {
    throw new Error("Failed to upload file")
  }

  return data as FileRes
}

export const cosineFetch = async <T>(
  path: string,
  method: Method = "get",
  body?: Record<string, any> | null,
  headers?: Record<string, any>,
  stream?: boolean,
): Promise<T> => {
  const res = await fetch(`${baseUrl}${path}`, {
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    credentials: "include",
    body: body ? JSON.stringify(body) : undefined,
    method,
  })
  let data: any
  if (stream) {
    data = res
  }
  if (res.headers.get("Content-Type")?.includes("application/json")) {
    data = await res.json()
  }

  if (!res.ok) {
    if (res.status === 402) {
      if ("BroadcastChannel" in window) {
        const channel = new window.BroadcastChannel("QUOTA_EXCEEDED")
        channel.postMessage({ quota: data.quota as ResourceUsage })
      }
    }

    const { message, ...rest } = data
    const error: ErrorCause = {
      message: message ?? res.statusText ?? "An error occurred",
      status: res.status,
      ...rest,
    }
    throw new Error(data.message, { cause: error })
  }
  return data as T
}

export type ErrorCause = {
  message: string
  status: number
  [key: string]: any
}

export const cosineGet = async <T>(
  path: string,
  params?: Record<string, any>,
  headers?: Record<string, any>,
  stream?: boolean,
) => {
  return cosineFetch<T>(path, "get", params, headers, stream)
}

export const cosinePost = async <T>(
  path: string,
  params?: Record<string, any>,
  headers?: Record<string, any>,
  stream?: boolean,
) => {
  return cosineFetch<T>(path, "post", params, headers, stream)
}

export const cosinePatch = async <T>(
  path: string,
  params?: Record<string, any>,
  headers?: Record<string, any>,
) => {
  return cosineFetch<T>(path, "PATCH", params, headers)
}

export const cosinePut = async <T>(
  path: string,
  params?: Record<string, any>,
  headers?: Record<string, any>,
) => {
  return cosineFetch<T>(path, "put", params, headers)
}

export const cosineDelete = async <T>(path: string, headers?: Record<string, any>) => {
  return cosineFetch<T>(path, "delete", headers)
}
